import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../../modules/react/components/stateless/Button';
import { resolveAssetUrl } from '../../../../../modules/assets';
import styles from './AddOnsList.scss';

const hasWidget = function (presentPage, type) {
  const { version } = presentPage;
  const section = version.sections.find(sct => sct.type === 'AddOns');
  return section ? section.widgets.some(widget => widget && widget.type === type) : false;
};

const renderIcon = (addOn, presentPage, onClick) => (
  <div className={styles.addOnItem} key={addOn.type}>
    <img className={styles.icon} src={addOn.src} alt={addOn.type} />
    {addOn.type === 'PopUp' ? 'Pop-up' : addOn.type}
    <Button
      variant="default"
      bsSize="small"
      className={styles.addOnButton}
      onClick={() => onClick(addOn.id, { type: addOn.type })}
      disabled={window.location.pathname.includes('/admin/layout/')}
    >
      {hasWidget(presentPage, addOn.type) ? 'Edit' : 'Add'}
    </Button>
  </div>
);

const addOns = [
  {
    type: 'PopUp',
    src: resolveAssetUrl('/img/pop-up-icon.svg'),
  },
];

const AddOnsList = props => (
  <div>{addOns.map(addOn => renderIcon(addOn, props.presentPage, props.onShowPopupModal))}</div>
);

AddOnsList.propTypes = {
  popUp: PropTypes.any,
  presentPage: PropTypes.any,
  onShowPopupModal: PropTypes.func,
};

AddOnsList.defaultProps = {
  popUp: {},
  presentPage: {},
};

export default AddOnsList;
